import { Injectable } from '@angular/core';
import { BaseEntity, ID } from '../model/baseentity';

@Injectable()
export class CacheService {
    private cachedData = new Map<string, any>();
    constructor() { }

    has(key: string) {
        return this.cachedData.has(key);
    }
    get(key: string) {
        return this.cachedData.get(key)
    }
    add(key: string, data: any) {
        this.cachedData.set(key, data)
    }
    remove(key) {
        this.cachedData.delete(key)
    }
    clear() {
        this.cachedData.clear();
    }

    hasEntity(entityName: string) {
        return this.has(`__entity__${entityName}`)
    }
    getEntity(entityName: string): BaseEntity[] {
        return this.get(`__entity__${entityName}`)
    }
    addEntity(entityName: string, data: BaseEntity[] | BaseEntity) {
        if (Array.isArray(data)) {
            this.add(`__entity__${entityName}`, data)
        } else {
            let datas = this.getEntity(entityName);
            let idx = datas.findIndex(it => it.id == data.id);
            if (idx == -1) {
                datas = [...datas, data]
            } else {
                datas = [...datas.slice(0, idx), data, ...datas.slice(idx + 1)]
            }
            this.add(`__entity__${entityName}`, datas)
        }
    }

    removeEntity(entityName: string): void;
    removeEntity(entityName: string, entity: BaseEntity | ID): void;
    removeEntity(entityName: string, entity?: BaseEntity | ID): void {
        if (!entity) {
            this.remove(`__entity__${entityName}`)
        } else {
            let datas = this.getEntity(entityName);
            let id = typeof (entity) == 'string' ? entity : entity.id
            datas = datas.filter(it => it.id != id)
            this.addEntity(entityName, datas)
        }
    }

}